import { HomeUI } from '../../modules';

const Home = () => {
  return (
    <>
      <HomeUI />
    </>
  );
};

export { Home };
